import classNames from 'classnames';

import type { DeserializedUserPublicProfile } from '@api';

import NextLink from '@shared/common/components/NextLink';
import { transformReview } from '@shared/helpers/review';

import ReviewCard from '@store:web/components/common/ReviewCard/ReviewCard';

import AppBlock from './AppBlock';
import UserHotOffers from './UserHotOffers';

const UserProjects = ({ data }: { data: DeserializedUserPublicProfile }) => {
  const reviews = data.reviews
    ?.slice(0, 2)
    ?.map((review) => transformReview({ review, user: data }));

  return (
    <div className="v2-container flex flex-col gap-7 md:gap-8">
      <AppBlock
        apps={data.appsVoted || []}
        title="Participants in validation"
        link={`/user/${data.attributes.magicId}/validations`}
        isFull={false}
      />

      <UserHotOffers
        hotOffers={data.claimedHotOffers}
        seeAllHref={`/user/${data.attributes.magicId}/claimed-hot-offers`}
      />

      <div className="w-full">
        <div className="lex-shrink-0 w-full flex justify-between items-start pb-4">
          <h2 className="t-h5 font-bold">Projects Reviews</h2>
          <NextLink
            href={`/user/${data.attributes.magicId}/reviews`}
            className="text-base transition-colors text-primary-600 hover:text-primary-700 whitespace-nowrap"
            data-qa="apps-block-see-all-button"
          >
            See all ››
          </NextLink>
        </div>
        <div
          className={classNames('grid gap-4', { 'md:grid-cols-2': !!reviews.length })}
          data-qa="apps-review-grid"
        >
          {reviews.map((review) => (
            <ReviewCard
              key={review.id}
              app={{
                appLink: review?.app?.attributes?.link || '',
                appName: review?.app?.attributes?.name || '',
              }}
              isShowApp={true}
              review={review}
              data-qa={`review-app-id-${review.id}`}
              className="h-auto mb-5 transition-none !cursor-default hover:!border-primary-100"
              readMoreUrl={`/user/${data.attributes.magicId}/${review.type}/${review.id}`}
            />
          ))}
          {!reviews.length && (
            <div className="w-full py-8">
              <h3 className="t-h4 text-center text-neutral-300">Empty!</h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProjects;
